export default __webpack_public_path__ + "static/joinThousandsOfStudents2-d0cdc13e5f06fe1cdf95825a12e7e810.png";